import React from 'react';
import { ComparisionTitle, ReportsContainer, ReportsItem } from './styled';

const Reports = ({ reportsData }) => {
  return (
    <>
      <ComparisionTitle>{reportsData?.heading}</ComparisionTitle>
      <ReportsContainer>
        {reportsData?.reports?.map((report, index) => (
          <ReportsItem key={'rep' + index}>
            <h4>{report.metric}</h4>
            <span>{report.description}</span>
          </ReportsItem>
        ))}
      </ReportsContainer>
    </>
  );
};

export default Reports;
